/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'plus': {
    width: 16,
    height: 16,
    viewBox: '0 0 16 16',
    data: '<path pid="0" d="M16 7.8H8.2V0h-.4v7.8H0v.4h7.8V16h.4V8.2H16z"/>'
  }
})
